import css from './Header.module.scss'
import React from 'react'
import { useTranslation } from 'react-i18next'

import DataTestId from 'meta/dataTestId'
import { Breakpoints } from 'meta/layout/breakpoints'
import { IWalletScreen } from 'meta/pages/v4/wallet'

import { GridColumn } from 'components/Layout/Grid'
import { useIsAppInitialized } from 'hooks/useApp'
import { useUrlCloudfront } from 'hooks/useEnv'

interface Props {
  activeScreen: IWalletScreen | null
  setActiveScreen(screen: IWalletScreen): void
}

const Header: React.FC<Props> = (props) => {
  const { activeScreen, setActiveScreen } = props

  const { t } = useTranslation()

  const appInitialized = useIsAppInitialized()
  const urlCloudfront = useUrlCloudfront()

  const backgroundImage = `url(${urlCloudfront}/images/wallet/header_bg${
    activeScreen === IWalletScreen.tickets ? '' : '_inv'
  }.svg)`

  return (
    <GridColumn
      gridColumnStart={{ [Breakpoints.mobile]: 1, [Breakpoints.laptop]: 6 }}
      gridColumnEnd={{ [Breakpoints.mobile]: 17, [Breakpoints.laptop]: 12 }}
      className={css.wrapper}
      style={{ backgroundImage, backgroundRepeat: 'no-repeat' }}
    >
      <button
        disabled={activeScreen === IWalletScreen.tickets || !appInitialized}
        onClick={() => setActiveScreen(IWalletScreen.tickets)}
        data-testId={DataTestId.wallet.btnHeaderTickets}
      >
        <h3>{t('wallet:tickets')}</h3>
      </button>
      <button
        disabled={activeScreen === IWalletScreen.good_service || !appInitialized}
        onClick={() => setActiveScreen(IWalletScreen.good_service)}
        data-testId={DataTestId.wallet.btnHeaderExtra}
      >
        <h3>{t('wallet:extra')}</h3>
      </button>
    </GridColumn>
  )
}

export default Header
